import { Navigate } from "react-router-dom";

import { RoleEnum, ROLES, RouteEnum } from "../common/models/enums";

interface IAppRoutesProps {
  allowedRoles: string[];
  children: JSX.Element;
  role: RoleEnum;
}

const RoleBasedRoute = ({
  allowedRoles,
  children,
  role,
}: IAppRoutesProps): JSX.Element => {
  const userRole = ROLES.find((r): boolean => r === role) ?? "";

  const allowed = allowedRoles?.includes(userRole);

  return allowed ? (
    <>{children}</>
  ) : (
    <Navigate to={RouteEnum.Unauthorized} replace />
  );
};

export default RoleBasedRoute;
